import { createFeatureSelector } from '@ngrx/store';

import { MessagingState, messagingStoreKeyname } from '../state';

export const selectMessagingStore = createFeatureSelector<MessagingState>(messagingStoreKeyname);
